import { Type } from 'class-transformer';

export class OwnershipResultDto {
  @Type(() => Date)
  closingDate: Date;
  additionalProperties: number;
}
